<div class="p-6 max-w-4xl mx-auto">

  <!-- Header -->
  <div class="mb-5">
    <nav class="flex items-center gap-1.5 text-xs text-gray-400 mb-2">
      <a routerLink="/automation/workflows" class="hover:text-blue-600">Workflows</a>
      <span>/</span>
      <span class="text-gray-600">Probar Webhooks</span>
    </nav>
    <div class="flex items-center gap-2 mb-1">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">Probar Webhooks</h1>
      <span class="px-2 py-0.5 text-xs bg-sky-100 text-sky-700 rounded-full font-medium">RF-10</span>
    </div>
    <p class="text-sm text-gray-500 dark:text-gray-400">
      Simula el envío de datos hacia un sistema externo (saliente) o la llegada de datos desde un sistema externo (entrante), sin necesidad de ejecutar un workflow completo.
    </p>
  </div>

  <!-- Tabs -->
  <div class="flex gap-1 mb-5 border-b border-gray-200 dark:border-gray-700">
    <button (click)="activeTab = 'outbound'"
            [ngClass]="activeTab === 'outbound' ? 'border-b-2 border-sky-600 text-sky-700 dark:text-sky-400' : 'text-gray-500 hover:text-gray-700'"
            class="px-4 py-2 text-sm font-medium transition-colors">
      Webhooks salientes
    </button>
    <button (click)="activeTab = 'inbound'"
            [ngClass]="activeTab === 'inbound' ? 'border-b-2 border-sky-600 text-sky-700 dark:text-sky-400' : 'text-gray-500 hover:text-gray-700'"
            class="px-4 py-2 text-sm font-medium transition-colors">
      Webhooks entrantes
    </button>
  </div>

  <!-- ── OUTBOUND ─────────────────────────────────────────────────────── -->
  @if (activeTab === 'outbound') {
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">

      <!-- Form -->
      <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
        <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Configuración saliente</h2>

        @if (outError) {
          <div class="mb-3 p-2 bg-red-50 border border-red-200 text-red-700 rounded text-xs flex justify-between">
            <span>{{ outError }}</span>
            <button (click)="outError = ''">&times;</button>
          </div>
        }

        <div class="space-y-3">
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de acción</label>
            <select [(ngModel)]="outActionType"
                    class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500">
              @for (opt of outActionOptions; track opt.value) {
                <option [value]="opt.value" [disabled]="opt.disabled">{{ opt.label }}</option>
              }
            </select>
            @if (isBlockedAction) {
              <p class="text-xs text-amber-600 mt-1">Esta acción se registra como SKIPPED en el backend.</p>
            }
          </div>

          <div class="grid grid-cols-2 gap-2">
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de objeto</label>
              <select [(ngModel)]="outObjectType" (ngModelChange)="onOutObjectTypeChange()"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500">
                @for (ot of objectTypeOptions; track ot.value) { <option [value]="ot.value">{{ ot.label }}</option> }
              </select>
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Registro</label>
              @if (recordSelect.isSearchable()) {
                <app-entity-select
                  [value]="outObjectId"
                  (valueChange)="outObjectId = $event"
                  (selected)="onRecordSelected($event)"
                  [displayText]="recordDisplayText"
                  [searchFn]="recordSelect.search" [labelFn]="recordSelect.label" [sublabelFn]="recordSelect.sublabel"
                  placeholder="Buscar por nombre…"></app-entity-select>
              } @else {
                <input type="number" [(ngModel)]="outObjectId" placeholder="Ej: 42"
                       class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500"/>
              }
            </div>
          </div>

          <div>
            <div class="flex items-center justify-between mb-1">
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300">URL del webhook</label>
              <button (click)="loadOutboundExample()" class="text-[10px] text-sky-600 hover:underline">Cargar ejemplo</button>
            </div>
            <input [(ngModel)]="outUrl" (ngModelChange)="onStructuredChange()" (focus)="setActiveField({ kind: 'url' })"
                   placeholder="https://mi-sistema-externo.com/webhook" type="text"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500"/>
            @if (outUrl && !outUrl.match('^https?://')) {
              <p class="text-[10px] text-amber-600 mt-0.5">La URL debe comenzar con http:// o https://</p>
            }
          </div>

          <div class="grid grid-cols-2 gap-2">
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Método HTTP</label>
              <select [(ngModel)]="outMethod" (ngModelChange)="onStructuredChange()"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500">
                @for (m of outMethodOptions; track m.value) { <option [value]="m.value">{{ m.label }}</option> }
              </select>
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tiempo máximo de espera (segundos)</label>
              <input type="number" min="1" max="120" [(ngModel)]="outTimeoutSeconds" (ngModelChange)="onStructuredChange()"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500"/>
            </div>
          </div>

          <!-- Headers -->
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Cabeceras</label>
            <div class="space-y-1.5">
              @for (row of outHeaders; track $index; let i = $index) {
                <div class="flex gap-1.5 items-center">
                  <input [(ngModel)]="row.key" (ngModelChange)="onStructuredChange()" placeholder="Nombre (ej: Authorization)"
                         class="w-2/5 px-2 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500"/>
                  <input [(ngModel)]="row.value" (ngModelChange)="onStructuredChange()" (focus)="setActiveField({ kind: 'header', index: i })"
                         placeholder="Valor"
                         class="flex-1 px-2 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500"/>
                  <button type="button" (click)="removeHeaderRow(i)" title="Quitar" class="p-1 text-gray-400 hover:text-red-600 shrink-0">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                  </button>
                </div>
              }
            </div>
            <button type="button" (click)="addHeaderRow()" class="mt-1 text-[11px] text-sky-600 hover:underline">+ Agregar cabecera</button>
          </div>

          <!-- Body -->
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Datos a enviar</label>
            <div class="space-y-1.5">
              @for (row of outBodyFields; track $index; let i = $index) {
                <div class="flex gap-1.5 items-center">
                  <input [(ngModel)]="row.key" (ngModelChange)="onStructuredChange()" placeholder="Campo (ej: email)"
                         class="w-2/5 px-2 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500"/>
                  <input [(ngModel)]="row.value" (ngModelChange)="onStructuredChange()" (focus)="setActiveField({ kind: 'body', index: i })"
                         placeholder="Valor o token"
                         class="flex-1 px-2 py-1.5 text-xs font-mono border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500"/>
                  <button type="button" (click)="removeBodyRow(i)" title="Quitar" class="p-1 text-gray-400 hover:text-red-600 shrink-0">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                  </button>
                </div>
              }
              @if (outBodyNonObject !== undefined) {
                <p class="text-[10px] text-amber-600">El body actual no es un objeto plano — edítalo en "Config avanzado (JSON)".</p>
              }
            </div>
            <button type="button" (click)="addBodyRow()" class="mt-1 text-[11px] text-sky-600 hover:underline">+ Agregar campo</button>

            @if (outTokenSuggestions.length) {
              <div class="mt-2 p-2 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-100 dark:border-gray-700">
                <p class="text-[10px] text-gray-400 mb-1">
                  Datos de {{ outObjectTypeLabel }} disponibles — haz clic en un campo (URL, cabecera o dato) y luego en un token para insertarlo:
                </p>
                <div class="flex flex-wrap gap-1">
                  @for (t of outTokenSuggestions; track t.token) {
                    <button type="button" (click)="insertToken(t.token)" [title]="t.label"
                            class="px-1.5 py-0.5 text-[10px] font-mono bg-sky-50 dark:bg-sky-900/30 text-sky-700 dark:text-sky-300 rounded border border-sky-200 dark:border-sky-800 hover:bg-sky-100 dark:hover:bg-sky-900/50 transition-colors">
                      {{ t.token }}
                    </button>
                  }
                </div>
              </div>
            }
          </div>

          <!-- Config avanzado (JSON) -->
          <details class="rounded-lg border border-gray-200 dark:border-gray-700 p-2" (toggle)="onAdvancedToggle($event)">
            <summary class="cursor-pointer text-xs font-medium text-gray-500 dark:text-gray-400 select-none">
              Config avanzado (JSON)
            </summary>
            <div class="mt-2">
              <p class="text-[10px] text-gray-400 mb-1">
                JSON completo enviado al backend (incluye <code>responseMapping</code>, <code>continueOnError</code>, etc. si existen). Los cambios aquí se reflejan en el formulario de arriba y viceversa.
              </p>
              <textarea [(ngModel)]="outAdvancedJson" (ngModelChange)="onAdvancedJsonChange()" rows="12"
                        class="w-full px-3 py-2 text-xs font-mono border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500 resize-none"></textarea>
              @if (outAdvancedJsonError) {
                <p class="text-[10px] text-red-600 mt-0.5">{{ outAdvancedJsonError }}</p>
              }
            </div>
          </details>

          <!-- Contexto adicional (avanzado) -->
          <details class="rounded-lg border border-gray-200 dark:border-gray-700 p-2">
            <summary class="cursor-pointer text-xs font-medium text-gray-500 dark:text-gray-400 select-none">
              Contexto adicional (opcional, avanzado)
            </summary>
            <div class="mt-2">
              <p class="text-[10px] text-gray-400 mb-1">
                Datos extra en JSON para simular el registro cuando no eliges uno real, o para sobreescribir algún valor puntual. La mayoría de las pruebas no necesitan esto.
              </p>
              <textarea [(ngModel)]="outContextJson" rows="3"
                        class="w-full px-3 py-2 text-xs font-mono border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500 resize-none"></textarea>
            </div>
          </details>

          <button (click)="testOutbound()" [disabled]="outLoading"
                  class="w-full py-2 text-sm bg-sky-600 text-white rounded-lg hover:bg-sky-700 disabled:opacity-50 transition-colors inline-flex items-center justify-center gap-2">
            @if (outLoading) {
              <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
              </svg>
              Enviando...
            } @else {
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
              </svg>
              Probar webhook
            }
          </button>
        </div>
      </div>

      <!-- Result -->
      <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
        <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Resultado</h2>

        @if (!outResult && !outLoading) {
          <div class="flex flex-col items-center justify-center py-10 text-gray-300 dark:text-gray-600">
            <svg class="w-10 h-10 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 10V3L4 14h7v7l9-11h-7z"/>
            </svg>
            <p class="text-sm">Envía un webhook para ver el resultado</p>
          </div>
        }

        @if (outLoading) {
          <div class="flex flex-col items-center justify-center py-10 text-gray-400">
            <svg class="animate-spin w-8 h-8 mb-3" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
            </svg>
            <p class="text-sm">Enviando webhook...</p>
          </div>
        }

        @if (outResult && !outLoading) {
          @if (outSummary; as s) {
            <div class="flex items-start gap-3 mb-4 p-3 rounded-lg"
                 [ngClass]="{
                   'bg-green-50 dark:bg-green-900/20': s.kind === 'success',
                   'bg-red-50 dark:bg-red-900/20': s.kind === 'error',
                   'bg-gray-50 dark:bg-gray-700/40': s.kind === 'skipped' || s.kind === 'unknown'
                 }">
              <span class="text-lg leading-none mt-0.5">
                {{ s.kind === 'success' ? '✔' : s.kind === 'error' ? '✘' : 'ℹ' }}
              </span>
              <div class="min-w-0">
                <p class="text-sm font-semibold"
                   [ngClass]="{
                     'text-green-700 dark:text-green-400': s.kind === 'success',
                     'text-red-700 dark:text-red-400': s.kind === 'error',
                     'text-gray-600 dark:text-gray-300': s.kind === 'skipped' || s.kind === 'unknown'
                   }">{{ s.title }}</p>
                @if (s.detail) {
                  <p class="text-xs text-gray-600 dark:text-gray-400 mt-0.5 break-words">{{ s.detail }}</p>
                }
              </div>
            </div>
          }

          @if (outResult.warnings?.length) {
            <div class="mb-3 p-2 bg-amber-50 border border-amber-200 rounded text-xs text-amber-700">
              @for (w of outResult.warnings!; track w) { <p>⚠ {{ w }}</p> }
            </div>
          }

          @if (outHasTechnicalDetail) {
            <details>
              <summary class="cursor-pointer text-xs text-gray-500 hover:text-gray-700 select-none">Ver detalle técnico</summary>
              <div class="mt-2 space-y-3">
                @if (outResult.output && (outResult.output | json) !== '{}') {
                  <div>
                    <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Resultado completo (JSON)</p>
                    <pre class="text-xs font-mono bg-gray-50 dark:bg-gray-700/40 p-3 rounded-lg overflow-x-auto text-gray-800 dark:text-gray-200 max-h-40 whitespace-pre-wrap">{{ outResultJson }}</pre>
                  </div>
                }
                @if (outResult.error && (outResult.error | json) !== '{}') {
                  <div>
                    <p class="text-xs font-semibold text-red-500 uppercase tracking-wide mb-1">Error</p>
                    <pre class="text-xs font-mono bg-red-50 dark:bg-red-900/20 p-3 rounded-lg overflow-x-auto text-red-800 dark:text-red-300 max-h-32 whitespace-pre-wrap">{{ outErrorJson }}</pre>
                  </div>
                }
              </div>
            </details>
          }
        }
      </div>
    </div>
  }

  <!-- ── INBOUND ──────────────────────────────────────────────────────── -->
  @if (activeTab === 'inbound') {
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">

      <!-- Form -->
      <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
        <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Configuración entrante</h2>
        <p class="text-xs text-gray-500 dark:text-gray-400 mb-3">
          Simula que un sistema externo (Stripe, un formulario, etc.) envía datos a una de tus conexiones.
        </p>

        @if (inError) {
          <div class="mb-3 p-2 bg-red-50 border border-red-200 text-red-700 rounded text-xs flex justify-between">
            <span>{{ inError }}</span>
            <button (click)="inError = ''">&times;</button>
          </div>
        }

        <div class="space-y-3">
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Conexión a probar *</label>
            @if (inEndpointsLoading) {
              <p class="text-xs text-gray-400">Cargando conexiones...</p>
            } @else {
              <select [(ngModel)]="inSelectedEndpoint" (ngModelChange)="onEndpointSelected()"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500">
                <option [ngValue]="null" disabled>Selecciona una conexión...</option>
                @for (ep of inEndpoints; track ep.id) {
                  <option [ngValue]="ep">{{ ep.name || ep.endpointKey }}</option>
                }
              </select>
              @if (inEndpoints.length === 0) {
                <p class="text-xs text-gray-400 mt-1">
                  No hay conexiones creadas. <a routerLink="/automation/workflow-webhooks/endpoints" class="text-sky-600 hover:underline">Crea una aquí</a>.
                </p>
              }
            }
          </div>

          @if (inSelectedEndpoint) {
            <div class="p-3 bg-sky-50 dark:bg-sky-900/20 border border-sky-200 dark:border-sky-800 rounded-lg text-xs space-y-1.5">
              <p class="font-semibold text-sky-700 dark:text-sky-400">{{ inSelectedEndpoint.name || inSelectedEndpoint.endpointKey }}</p>
              @if (inSelectedEndpoint.description) {
                <p class="text-gray-500 dark:text-gray-400">{{ inSelectedEndpoint.description }}</p>
              }
              <p class="text-gray-600 dark:text-gray-300">
                Workflow asociado: <span class="font-medium">{{ inSelectedEndpoint.workflowName ?? ('#' + inSelectedEndpoint.idWorkflow) }}</span>
              </p>
              <p class="text-gray-600 dark:text-gray-300 flex items-center gap-1">
                Clave de seguridad:
                @if (inSelectedEndpoint.hasSecret) {
                  <span class="text-green-600 dark:text-green-400 font-medium">Configurada — es obligatoria</span>
                } @else {
                  <span class="text-amber-600 font-medium">No configurada</span>
                }
              </p>
              <div class="flex items-center gap-1.5 bg-white dark:bg-gray-800 rounded p-1.5 mt-1">
                <span class="font-mono text-[11px] text-sky-700 dark:text-sky-400 break-all">{{ inEndpointUrl }}</span>
              </div>
              <p class="text-[10px] text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded p-1.5 mt-1">
                ⚠ Esta prueba envía una petición real a esta URL, tal como lo haría un sistema externo.
              </p>
            </div>
          }

          @if (inSelectedEndpoint?.matchObjectType) {
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Registro ({{ inObjectTypeLabel }})</label>
              @if (inRecordsLoading) {
                <p class="text-xs text-gray-400">Cargando...</p>
              } @else {
                <select [(ngModel)]="inObjectId" (ngModelChange)="onInObjectIdChange()"
                        class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500">
                  <option [ngValue]="null">Ninguno</option>
                  @for (r of inRecords; track r.id) { <option [ngValue]="r.id">{{ r.label }}</option> }
                </select>
              }
              <p class="text-[10px] text-gray-400 mt-1">Al seleccionar, se actualiza el ID en los datos a enviar automáticamente.</p>
            </div>
          }

          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Clave de seguridad <span class="text-gray-400 font-normal">(opcional)</span></label>
            <input type="password" autocomplete="off" [(ngModel)]="inSecret" placeholder="Dejar vacío si la conexión no tiene"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500"/>
          </div>

          <!-- Datos a enviar (payload) -->
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Datos a enviar</label>
            <div class="space-y-1.5">
              @for (row of inPayloadFields; track $index; let i = $index) {
                <div class="flex gap-1.5 items-center">
                  <input [(ngModel)]="row.key" (ngModelChange)="onInStructuredChange()" placeholder="Campo (ej: dealId)"
                         class="w-2/5 px-2 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500"/>
                  <input [(ngModel)]="row.value" (ngModelChange)="onInStructuredChange()"
                         placeholder="Valor"
                         class="flex-1 px-2 py-1.5 text-xs font-mono border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500"/>
                  <button type="button" (click)="removePayloadRow(i)" title="Quitar" class="p-1 text-gray-400 hover:text-red-600 shrink-0">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                  </button>
                </div>
              }
              @if (inPayloadNonObject !== undefined) {
                <p class="text-[10px] text-amber-600">Los datos actuales no son un objeto plano — edítalos en "Datos avanzados (JSON)".</p>
              }
            </div>
            <button type="button" (click)="addPayloadRow()" class="mt-1 text-[11px] text-sky-600 hover:underline">+ Agregar campo</button>
          </div>

          <!-- Datos avanzados (JSON) -->
          <details class="rounded-lg border border-gray-200 dark:border-gray-700 p-2" (toggle)="onInAdvancedToggle($event)">
            <summary class="cursor-pointer text-xs font-medium text-gray-500 dark:text-gray-400 select-none">
              Datos avanzados (JSON)
            </summary>
            <div class="mt-2">
              <p class="text-[10px] text-gray-400 mb-1">
                JSON completo que se enviará como cuerpo de la petición. Los cambios aquí se reflejan arriba y viceversa.
              </p>
              <textarea [(ngModel)]="inAdvancedJson" (ngModelChange)="onInAdvancedJsonChange()" rows="8"
                        class="w-full px-3 py-2 text-xs font-mono border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-sky-500 resize-none"></textarea>
              @if (inAdvancedJsonError) {
                <p class="text-[10px] text-red-600 mt-0.5">{{ inAdvancedJsonError }}</p>
              }
            </div>
          </details>

          <button (click)="testInbound()" [disabled]="inLoading"
                  class="w-full py-2 text-sm bg-sky-600 text-white rounded-lg hover:bg-sky-700 disabled:opacity-50 transition-colors inline-flex items-center justify-center gap-2">
            @if (inLoading) {
              <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
              </svg>
              Enviando...
            } @else {
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
              </svg>
              Enviar datos de prueba
            }
          </button>
        </div>
      </div>

      <!-- Result -->
      <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
        <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Resultado</h2>

        @if (!inResult && !inLoading) {
          <div class="flex flex-col items-center justify-center py-10 text-gray-300 dark:text-gray-600">
            <svg class="w-10 h-10 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <p class="text-sm">Envía los datos de prueba para ver el resultado</p>
          </div>
        }

        @if (inLoading) {
          <div class="flex flex-col items-center justify-center py-10 text-gray-400">
            <svg class="animate-spin w-8 h-8 mb-3" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
            </svg>
            <p class="text-sm">Procesando...</p>
          </div>
        }

        @if (inResult && !inLoading) {
          <div class="space-y-3">
            <div class="flex items-center gap-2 p-3 rounded-lg"
                 [ngClass]="inResult.ignored ? 'bg-gray-50 dark:bg-gray-700/40' : (inResult.createdEnrollments?.length ? 'bg-green-50 dark:bg-green-900/20' : 'bg-blue-50 dark:bg-blue-900/20')">
              <p class="text-sm font-medium"
                 [ngClass]="inResult.ignored ? 'text-gray-600 dark:text-gray-400' : (inResult.createdEnrollments?.length ? 'text-green-700 dark:text-green-400' : 'text-blue-700 dark:text-blue-400')">
                {{ inResult.ignored ? 'Evento ignorado' : (inResult.createdEnrollments?.length ? 'Se creó la inscripción en el workflow' : 'Evento procesado') }}
              </p>
            </div>

            @if (inResult.message) {
              <p class="text-xs text-gray-600 dark:text-gray-400">{{ inResult.message }}</p>
            }

            <dl class="grid grid-cols-2 gap-2 text-xs">
              @if (inResult.matchedWorkflows !== undefined) {
                <div class="bg-gray-50 dark:bg-gray-700/40 rounded p-2">
                  <dt class="text-[10px] text-gray-500">Workflows coincidentes</dt>
                  <dd class="font-semibold text-gray-900 dark:text-white">{{ inResult.matchedWorkflows }}</dd>
                </div>
              }
              @if (inResult.createdEnrollments !== undefined) {
                <div class="bg-gray-50 dark:bg-gray-700/40 rounded p-2">
                  <dt class="text-[10px] text-gray-500">Inscripciones creadas</dt>
                  <dd class="font-semibold text-gray-900 dark:text-white">{{ inResult.createdEnrollments?.length ?? 0 }}</dd>
                </div>
              }
            </dl>

            @if (inResult.createdEnrollments?.length) {
              <div class="space-y-1">
                @for (en of inResult.createdEnrollments; track en.id) {
                  <div class="flex items-center gap-2 p-2 bg-green-50 dark:bg-green-900/20 rounded text-xs">
                    <span class="font-mono text-green-700 dark:text-green-400">#{{ en.id }}</span>
                    <span class="text-green-600 dark:text-green-500">{{ recordText(en.objectType, en.objectId) }}</span>
                    <span class="px-1.5 py-0.5 bg-green-100 text-green-700 rounded-full text-[10px]">{{ statusText(en.status) }}</span>
                  </div>
                }
              </div>
            }

            @if (inResult.errors?.length) {
              <div class="p-2 bg-red-50 border border-red-200 rounded text-xs text-red-600">
                @for (e of inResult.errors; track e) { <p>• {{ e }}</p> }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  <!-- Navigation links -->
  <div class="mt-6 flex flex-wrap gap-2">
    <a routerLink="/automation/workflow-webhooks/endpoints" [replaceUrl]="true"
       class="inline-flex items-center gap-1 px-3 py-1.5 text-xs border border-sky-200 dark:border-sky-800 text-sky-600 dark:text-sky-400 rounded-lg hover:bg-sky-50 dark:hover:bg-sky-900/20 transition-colors">
      Endpoints Webhook
    </a>
    <a routerLink="/automation/workflow-actions/test" [replaceUrl]="true"
       class="inline-flex items-center gap-1 px-3 py-1.5 text-xs border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/40 transition-colors">
      Probar Acciones
    </a>
  </div>
</div>
